import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import * as Icons from './icons';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Dispatcher = ({
    className = null,
    name      = null
}) => {
    // references
    const containerRef = useRef(null);

    let Component;
    if (Icons[name]) {
        Component = Icons[name];
    } else {
        Component = null;
    }

    // render
    return (
        <div
            className={className ?? 'icon'}
            ref={containerRef}>
            <Component />
        </div>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    className: PropTypes.string,
    name     : PropTypes.string.isRequired
};

Dispatcher.propTypes = propTypes;

Dispatcher.displayName = 'IconDispatcher';

export { Dispatcher };

export default Dispatcher;
